export default __webpack_public_path__ + "c498e203e5a0a635b908431011c0a1e7.png";